/*
Copyright 2022 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/
import { css } from '@spectrum-web-components/base';
const styles = css`
:host{--spectrum-treeview-heading-font-weight:var(
--spectrum-global-font-weight-bold,700
);--spectrum-treeview-item-hover-offset:var(
--spectrum-global-dimension-size-25
);--spectrum-treeview-item-border-size-selected:var(
--spectrum-alias-border-size-thin,var(--spectrum-global-dimension-static-size-10)
)}:host([size=s]){--spectrum-treeview-item-text-padding-top:var(
--spectrum-treeview-s-item-text-padding-top,var(--spectrum-global-dimension-static-size-50)
);--spectrum-treeview-item-indentation:var(
--spectrum-treeview-s-item-indentation,var(--spectrum-global-dimension-size-150)
);--spectrum-treeview-item-min-height:var(
--spectrum-treeview-s-item-min-height,var(--spectrum-global-dimension-size-300)
);--spectrum-treeview-item-border-radius:var(
--spectrum-treeview-s-item-border-radius,var(--spectrum-global-dimension-static-size-0)
);--spectrum-treeview-item-padding-left:var(
--spectrum-treeview-s-item-padding-left,var(--spectrum-global-dimension-static-size-0)
);--spectrum-treeview-item-padding-right:var(
--spectrum-treeview-s-item-padding-right,var(--spectrum-global-dimension-size-115)
);--spectrum-treeview-item-padding-top:var(
--spectrum-treeview-s-item-padding-top,var(--spectrum-global-dimension-static-size-0)
);--spectrum-treeview-item-padding-bottom:var(
--spectrum-treeview-s-item-padding-bottom,var(--spectrum-global-dimension-static-size-0)
);--spectrum-treeview-item-border-size:var(
--spectrum-treeview-s-item-border-size,var(--spectrum-global-dimension-static-size-25)
);--spectrum-treeview-item-affordance-size:var(
--spectrum-treeview-s-item-affordance-size,var(--spectrum-global-dimension-size-300)
);--spectrum-treeview-s-item-icon-gap:var(
--spectrum-global-dimension-size-85
)}:host([size=m]){--spectrum-treeview-item-text-padding-top:var(
--spectrum-treeview-m-item-text-padding-top,var(--spectrum-global-dimension-size-75)
);--spectrum-treeview-item-text-padding-bottom:var(
--spectrum-treeview-m-item-text-padding-bottom,var(--spectrum-global-dimension-size-115)
);--spectrum-treeview-item-indentation:var(
--spectrum-treeview-m-item-indentation,var(--spectrum-global-dimension-size-200)
);--spectrum-treeview-item-min-height:var(
--spectrum-treeview-m-item-min-height,var(--spectrum-global-dimension-size-300)
);--spectrum-treeview-item-border-radius:var(
--spectrum-treeview-m-item-border-radius,var(--spectrum-global-dimension-static-size-0)
);--spectrum-treeview-item-padding-left:var(
--spectrum-treeview-m-item-padding-left,var(--spectrum-global-dimension-static-size-0)
);--spectrum-treeview-item-padding-right:var(
--spectrum-treeview-m-item-padding-right,var(--spectrum-global-dimension-size-150)
);--spectrum-treeview-item-padding-top:var(
--spectrum-treeview-m-item-padding-top,var(--spectrum-global-dimension-static-size-0)
);--spectrum-treeview-item-padding-bottom:var(
--spectrum-treeview-m-item-padding-bottom,var(--spectrum-global-dimension-static-size-0)
);--spectrum-treeview-item-border-size:var(
--spectrum-treeview-m-item-border-size,var(--spectrum-global-dimension-static-size-25)
);--spectrum-treeview-item-affordance-size:var(
--spectrum-treeview-m-item-affordance-size,var(--spectrum-global-dimension-size-400)
)}:host([size=l]){--spectrum-treeview-item-text-padding-bottom:var(
--spectrum-treeview-l-item-text-padding-bottom,var(--spectrum-global-dimension-size-130)
);--spectrum-treeview-item-indentation:var(
--spectrum-treeview-l-item-indentation,var(--spectrum-global-dimension-size-250)
);--spectrum-treeview-item-min-height:var(
--spectrum-treeview-l-item-min-height,var(--spectrum-global-dimension-size-400)
);--spectrum-treeview-item-border-radius:var(
--spectrum-treeview-l-item-border-radius,var(--spectrum-global-dimension-static-size-0)
);--spectrum-treeview-item-padding-left:var(
--spectrum-treeview-l-item-padding-left,var(--spectrum-global-dimension-static-size-0)
);--spectrum-treeview-item-padding-right:var(
--spectrum-treeview-l-item-padding-right,var(--spectrum-global-dimension-size-185)
);--spectrum-treeview-item-padding-top:var(
--spectrum-treeview-l-item-padding-top,var(--spectrum-global-dimension-static-size-0)
);--spectrum-treeview-item-padding-bottom:var(
--spectrum-treeview-l-item-padding-bottom,var(--spectrum-global-dimension-static-size-0)
);--spectrum-treeview-item-border-size:var(
--spectrum-treeview-l-item-border-size,var(--spectrum-global-dimension-static-size-25)
);--spectrum-treeview-item-affordance-size:var(
--spectrum-treeview-l-item-affordance-size,var(--spectrum-global-dimension-size-500)
)}:host([size=xl]){--spectrum-treeview-item-text-padding-top:var(
--spectrum-treeview-xl-item-text-padding-top,var(--spectrum-global-dimension-size-150)
);--spectrum-treeview-item-text-padding-bottom:var(
--spectrum-treeview-xl-item-text-padding-bottom,var(--spectrum-global-dimension-size-175)
);--spectrum-treeview-item-indentation:var(
--spectrum-treeview-xl-item-indentation,var(--spectrum-global-dimension-size-300)
);--spectrum-treeview-item-min-height:var(
--spectrum-treeview-xl-item-min-height,var(--spectrum-global-dimension-size-500)
);--spectrum-treeview-item-border-radius:var(
--spectrum-treeview-xl-item-border-radius,var(--spectrum-global-dimension-static-size-0)
);--spectrum-treeview-item-padding-left:var(
--spectrum-treeview-xl-item-padding-left,var(--spectrum-global-dimension-static-size-0)
);--spectrum-treeview-item-padding-right:var(
--spectrum-treeview-xl-item-padding-right,var(--spectrum-global-dimension-size-225)
);--spectrum-treeview-item-padding-top:var(
--spectrum-treeview-xl-item-padding-top,var(--spectrum-global-dimension-static-size-0)
);--spectrum-treeview-item-padding-bottom:var(
--spectrum-treeview-xl-item-padding-bottom,var(--spectrum-global-dimension-static-size-0)
);--spectrum-treeview-item-border-size:var(
--spectrum-treeview-xl-item-border-size,var(--spectrum-global-dimension-static-size-25)
);--spectrum-treeview-item-affordance-size:var(
--spectrum-treeview-xl-item-affordance-size,var(--spectrum-global-dimension-size-600)
)}:host{display:block;list-style:none;outline:none;padding:0;position:relative;-webkit-user-select:none;user-select:none}:host([dir=ltr]) ::slotted(sp-tree-view){padding-left:var(
--spectrum-treeview-item-indentation
)}:host([dir=rtl]) ::slotted(sp-tree-view){padding-right:var(
--spectrum-treeview-item-indentation
)}sp-tree-view{height:0;position:static;visibility:hidden}:host{--spectrum-treeview-item-background-color-selected:var(
--spectrum-alias-highlight-selected
);--spectrum-treeview-item-background-color-quiet-selected:var(
--spectrum-alias-highlight-hover
);--spectrum-treeview-item-icon-color:var(
--spectrum-alias-icon-color,var(--spectrum-global-color-gray-700)
);--spectrum-treeview-item-icon-color-hover:var(
--spectrum-alias-icon-color-hover,var(--spectrum-global-color-gray-900)
);--spectrum-treeview-item-icon-color-focus:var(
--spectrum-alias-icon-color-key-focus,var(--spectrum-global-color-gray-900)
);--spectrum-treeview-item-icon-color-selected:var(
--spectrum-alias-icon-color-selected-neutral,var(--spectrum-global-color-gray-900)
);--spectrum-treeview-item-icon-color-disabled:var(
--spectrum-alias-icon-color-disabled,var(--spectrum-global-color-gray-400)
);--spectrum-treeview-m-item-text-color-selected:var(
--spectrum-alias-text-color-selected-neutral,var(--spectrum-global-color-gray-900)
)}
`;
export default styles;